var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-audio-recorder",class:{
    'active': _vm.isRecording,
    'paused': _vm.isPaused
  },on:{"mousedown":_vm.start,"mouseup":_vm.stop}},[_c('v-icon',{attrs:{"left":"","color":"white"}},[_vm._v(" mdi-microphone ")]),_vm._v(" "+_vm._s(_vm.isRecording ? 'Recording...' : 'Record')+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }